import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class Provider extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  emailAddress: string;

  @autoserialize
  claraProviderIdentifier: number;

  @autoserialize
  active: boolean;
}
